import { FC, PropsWithChildren } from 'react';

interface DangerousHTMLProps extends React.HTMLAttributes<HTMLElement> {
  content: string;
}

export const DangerousHTML: FC<PropsWithChildren<DangerousHTMLProps>> = ({ content, children, ...props }) => {
  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content }}
      {...props}
    >
      {children}
    </div>
  );
};
